/**
 * https://morioh.com/p/ca1388312253
 */

// import { YoutubeVue } from 'youtube-vue';
import YouTubePlayer from 'youtube-player';

export default {
    name: 'video-youtube',

    data () {
        return {
            iframeState: true,
            iframeId: 'video_' + this.videourl,
            play: {
                video_id: this.videourl,
                loop: 0
            },
            ready: 0,
            isplay: 'youtube-player'
        };
    },

    props: {
        videourl: {
            type: String,
            default: ''
        }
    },

    mounted () {
        let playerVars = {
            autoplay: 0,
            loop: 0
        };

        this.player = YouTubePlayer(this.iframeId, {
            host: 'https://www.youtube.com',
            width: 480,
            height: 320,
            videoId: this.videourl,
            playerVars: playerVars
        });

        this.player.on('stateChange', (e) => {
            if (e.data === window.YT.PlayerState.ENDED) {
                this.stopCurrentVideo();
            } else if (e.data === window.YT.PlayerState.PAUSED) {
                this.pauseCurrentVideo();
            } else if (e.data === window.YT.PlayerState.PLAYING) {
                console.log('play');
            }
        });
    },

    watch: {
        videoid () {
            this.player.loadVideoById(this.videourl);
        }
    },

    methods: {
        playCurrentVideo () {
            document.querySelector('iframe').contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
            this.player.playVideo();
            this.isplay = 'youtube-player play';
        },
        stopCurrentVideo () {
            this.player.stopVideo();
            this.isplay = 'youtube-player';
        },
        pauseCurrentVideo () {
            this.player.pauseVideo();
            this.isplay = 'youtube-player';
        }
    },

    computed: {
        hqdefault () {
            return 'https://i.ytimg.com/vi/' + this.videourl + '/hqdefault.jpg';
        }
    }
};
